<template>
<div class="home container-fixed">

    <div class="intro-container">
        <h1 class="text-center pb-3">   
            {{ 'MAIN_HEADER' | translate }}
        </h1>
        <div class="row justify-content-center mt-4">
            <div class="col-6 col-sm-4 col-lg-2">
                <BlockHead :blockhead="mockHeads[5]" />
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
                <BlockHead :blockhead="mockHeads[4]" />
            </div>
            <div class="col-sm-4 col-lg-2 d-none d-sm-block">
                <BlockHead :blockhead="mockHeads[3]" />
            </div>
            <div class="col-lg-2 d-none d-lg-block">
                <BlockHead :blockhead="mockHeads[1]" />
            </div>
            <div class="col-lg-2 d-none d-lg-block">
                <BlockHead :blockhead="mockHeads[2]" />
            </div>
        </div>
    </div>
    <div v-if="games.length > 0 && blockHeads.length > 0 && users.length > 0" class="intro-container">
        <div class="row justify-content-center text-center mt-3 mb-3">
            <div class="col-4 col-sm-3">
                <header>
                    {{ 'WARS_CREATED' | translate }}
                </header>
                <div class="intro-stat">
                    {{ games.length }}
                </div>
            </div>
            <div class="col-4 col-sm-3">
                <header>
                    {{ 'HEADS_CREATED' | translate }}
                </header>
                <div class="intro-stat">
                    {{ blockHeads.length }}
                </div>
            </div>
            <div class="col-4 col-sm-3">
                <header>
                    {{ 'USERS_JOINED' | translate }}
                </header>
                <div class="intro-stat">
                    {{ users.length }}
                </div>
            </div>
        </div>
    </div>

    <div class="row no-gutters justify-content-center">
    
        <div class="col-md-4 mt-4 mb-4 text-center">
            <button v-if="!pendingTransaction" @click="openModal" class="btn btn-primary">
                {{ 'CREATE_BLOCKWAR' | translate }}
            </button>
            <button v-else class="btn btn-secondary">
                {{ 'PLEASE_WAIT' | translate }}
            </button>
            <button v-if="!pendingTransaction" @click="goToRoute('profile')" class="btn btn-primary">
                {{ 'GET_BLOCKHEADS' | translate }}
            </button>
            <button v-else class="btn btn-secondary">
                {{ 'PLEASE_WAIT' | translate }}
            </button>
            <button @click="openAboutModal" class="btn btn-primary">
                {{ 'READ_RULES' | translate }}
            </button>
        </div>

    </div>    

    <div class="row no-gutters">
        
        <div v-if="!games || games.length == 0" class="col-md-12 mb-2 text-center">
            <div v-if="!loadingBlockWars" class="intro-container">
                {{ 'NO_GAMES_PLEASE_MAKE_ONE' | translate }}
            </div>
            <div v-else class="intro-container">
                {{ 'LOADING_PLEASE_WAIT' | translate }}
            </div>
        </div>

        <div v-for="(game, index) in games" :key="index" class="col-12 col-sm-12 col-md-6 col-lg-4">
            <div class="blockwar-item">
                <div class="row no-gutters mb-4">
                    <div class="col-12 text-center">
                        <div v-if="!game.isComplete && !game.winner" class="main-header">
                            {{ 'REWARD_POOL' | translate }} - {{ fromWei(game.rewardPool) }} NAS
                        </div>   
                        <div v-else-if="game.isComplete && game.winner" class="main-header winner">
                            {{ 'WOW' | translate }} {{ game.winner.substr(game.winner.length-4, 4) }} - {{ 'WON' | translate }} {{ fromWei(game.rewardPool) }} NAS
                        </div>                    
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-4">
                        <header>
                            {{ 'OWNER' | translate }}
                        </header>
                        <div>
                            {{ game.owner.substr(game.owner.length-4, 4) }}
                        </div>
                    </div>
                    <div class="col-4">
                        <header>
                            {{ 'GRID_SIZE' | translate }}
                        </header>
                        <div>
                            {{ game.gridSize }}
                        </div>
                    </div>
                    <div class="col-4">
                        <header>
                            {{ 'STATUS' | translate }}
                        </header>
                        <div>
                            {{ game.isComplete ? 'Closed' : 'Open' }}
                        </div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-4">
                        <header>
                            {{ 'PLAYER_ALLOWANCE' | translate }}
                        </header>
                        <div>
                            {{ game.playerAllowance }}
                        </div>
                    </div>
                    <div class="col-4">
                        <header>
                            {{ 'PRICE_TO_PLAY' | translate }}
                        </header>
                        <div>
                            {{ game.price }} NAS
                        </div>
                    </div>
                    <div class="col-4">
                        <header>
                            {{ 'COMPLETED' | translate }}
                        </header>
                        <div>
                            {{ game.blocksPlayed / game.gridSize * 100 }} %
                        </div>
                    </div>
                </div>
                <div class="row pt-2">
                    <div class="col-12 text-center">
                         <button v-if="!game.isComplete" @click="goToRoute('game', game.id)" class="btn btn-primary">
                            {{ 'PLAY' | translate }}
                        </button>
                        <button v-else @click="goToRoute('game', game.id)" class="btn btn-secondary">
                            {{ 'VIEW' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>

</template>

<script>
import { mapGetters } from "vuex";
import TheBanner from "../components/layout/TheBanner";
import { contractAddress, nebPay, neb } from "../util/nebulas";
import BlockHead from "../components/BlockHead";
import { mockHeads } from "../util/mockHeads";

export default {
    name: "Home",
    computed: {
        ...mapGetters({
            users: 'getUsers',
            games: 'getGames',
            address: 'getAddress',
            blockHeads: 'getBlockHeads',
            loadingBlockWars: 'getLoadingBlockWars',
            pendingTransaction: 'getPendingTransaction'
        })
    },
    components: { BlockHead },
    data() {
        return {
            mockHeads: mockHeads
        };
    },
    methods: {
        openModal () {
            this.$root.$emit('bv::show::modal','modal-create');
        },

        openAboutModal () {
            this.$root.$emit('bv::show::modal','modal-about');
        },

        fromWei (amount) {
            return neb.fromBasic(amount, "nas").toNumber();  
        },
        
        goToRoute (_name, _id) {

            if (name == 'game') {
                this.$store.commit('setGame', { id: _id });             
            } 

            this.$router.push({ name: _name, params: { id: _id }});

        }
    }
};
</script>

<style lang="less">
@import "../assets/less/app.less";
@navFontFamily: 'Cabin Sketch', cursive;

.home {
    color: #fff;
    padding: 0 10px 20px;
    overflow-x: hidden;

    .intro-container {
        padding: 40px;
        margin: 0 5px;
        background: #3C3F44;
        border-bottom: 3px solid #222532;

        header {
            color: #88929B;
        }

        .intro-stat {
            font-family: @navFontFamily;
            font-size: 30px;
        }

        .blockhead-item {
            height: 180px;
            padding-top: 40px;
        }

        h1, h2 {
            font-family: @navFontFamily;
        }
    }
}

.blockwar-item {
    background: #3C3F44;
    border: 3px solid #222532;
    margin: 0 5px 12px;
    padding: 25px 0;
    text-align: center;

    .main-header {
        font-size: 20px;
        padding-bottom: 20px;
        border-bottom: 3px solid #222532;

        &.winner {
            color:#83a485;
        }
    }

    header {
        color: #96999C; 
    }
}

// Other
.content-container {
    cursor: default!important;
}

.home {
    .no-content {
        font-weight: bold;
        font-size: 24px;
        padding: 150px 0;
        text-align: center;
    }

    .content-body {
        position: relative;
        
        .fee {
            font-size: 13px;
            font-weight: bold;
        }
        .content-row {
            padding: 50px 0;
            text-align: center;
            

            h1 {
                margin: 20px 0 30px;
            }

            .versus {
                font-size: 32px;
                color: #000;
                position: relative;
                top: 40%;
            }


            .action-container {
                margin-top: 30px;
            }
        }

        .shape {
            width: 25%;
            position: absolute;
            opacity: 0.1;
            z-index: -1;

            &.one {
                height: 100%;
                left: 0;
                top: 0;
                background: #8E2DE2;
                -webkit-clip-path: polygon(0% 0%, 50% 100%, 0% 100%);
                clip-path: polygon(0% 0%, 40% 100%, 0% 100%);

                &.top {
                    -webkit-clip-path: polygon(0% 0%, 48% 0%, 0% 99%);
                    clip-path: polygon(0% 0%, 40% 0%, 0% 100%);
                }

                &.large {
                    -webkit-clip-path: polygon(0% 0%, 50% 100%, 0% 100%);
                    clip-path: polygon(0% 0%, 40% 0%, 0% 100%);
                }
            }

            &.two {
                height: 100%;
                right: 0;
                top: 0;
                background: #8E2DE2;
                -webkit-clip-path: polygon(1% 100%, 100% 1%, 99% 98%);
                clip-path: polygon(60% 100%, 100% 0%, 100% 100%);

                &.top {
                    -webkit-clip-path: polygon(100% 1%, 59% 0%, 100% 99%);
                    clip-path: polygon(100% 0%, 60% 0%, 100% 100%);
                }

                &.large {
                        -webkit-clip-path: polygon(1% 100%, 100% 1%, 99% 98%);
                    clip-path: polygon(60% 0%, 100% 0%, 100% 100%);
                }
            }
        }

    }
}

// Tablet device
@media only screen and (max-width: 768px) {
    body {
        .versus {
            margin: 30px 0;
            top: 0!important;
        }
    }
}

// Phone device
@media only screen and (max-width: 480px) {
     body {
        .shape {
            display: none!important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue